import { ts } from '_core';

const defaultAlpha: ts.types.signal.FixedWeightsDraft = {
  signals: [],
  skipna: true,
  abs_weight_norm: true,
};

export default defaultAlpha;
